/**
 * Fiskal Cloud Management Admin API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.1.0
 * Contact: info@deutsche-fiskal.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { BusinessPremisesWithStatusLogDTO } from '../model/models';
import { BusinessPremisesWithStatusLogResultResponseDTO } from '../model/models';
import { ErsWithStatusLogDTO } from '../model/models';
import { ErsWithStatusLogResultResponseDTO } from '../model/models';
import { OrganizationWithStatusLogDTO } from '../model/models';
import { OrganizationWithStatusLogResultResponseDTO } from '../model/models';
import { TenantWithStatusLogDTO } from '../model/models';
import { TenantWithStatusLogResultResponseDTO } from '../model/models';
import { VirtualTssWithStatusLogDTO } from '../model/models';
import { VirtualTssWithStatusLogResultResponseDTO } from '../model/models';


import { Configuration }                                     from '../configuration';


export interface GetBusinessPremisesStatusLogByIdRequestParams {
    businessPremisesId: string;
}

export class ClsGetBusinessPremisesStatusLogByIdRequestParams {
    businessPremisesId: string = undefined;
}

export interface GetBusinessPremisesStatusLogsRequestParams {
    businessPremisesId?: string;
    tenantId?: string;
    userId?: string;
    from?: string;
    to?: string;
    pageSize?: number;
    pageNumber?: number;
    sort?: string;
}

export class ClsGetBusinessPremisesStatusLogsRequestParams {
    businessPremisesId?: string = undefined;
    tenantId?: string = undefined;
    userId?: string = undefined;
    from?: string = undefined;
    to?: string = undefined;
    pageSize?: number = undefined;
    pageNumber?: number = undefined;
    sort?: string = undefined;
}

export interface GetErsStatusLogByIdRequestParams {
    ersId: string;
}

export class ClsGetErsStatusLogByIdRequestParams {
    ersId: string = undefined;
}

export interface GetErsStatusLogsRequestParams {
    ersId?: string;
    tenantId?: string;
    userId?: string;
    from?: string;
    to?: string;
    pageSize?: number;
    pageNumber?: number;
    sort?: string;
}

export class ClsGetErsStatusLogsRequestParams {
    ersId?: string = undefined;
    tenantId?: string = undefined;
    userId?: string = undefined;
    from?: string = undefined;
    to?: string = undefined;
    pageSize?: number = undefined;
    pageNumber?: number = undefined;
    sort?: string = undefined;
}

export interface GetOrganizationStatusLogByIdRequestParams {
    organizationId: string;
}

export class ClsGetOrganizationStatusLogByIdRequestParams {
    organizationId: string = undefined;
}

export interface GetOrganizationStatusLogsRequestParams {
    organizationId?: string;
    tenantId?: string;
    userId?: string;
    from?: string;
    to?: string;
    pageSize?: number;
    pageNumber?: number;
    sort?: string;
}

export class ClsGetOrganizationStatusLogsRequestParams {
    organizationId?: string = undefined;
    tenantId?: string = undefined;
    userId?: string = undefined;
    from?: string = undefined;
    to?: string = undefined;
    pageSize?: number = undefined;
    pageNumber?: number = undefined;
    sort?: string = undefined;
}

export interface GetTenantStatusLogByIdRequestParams {
    tenantId: string;
}

export class ClsGetTenantStatusLogByIdRequestParams {
    tenantId: string = undefined;
}

export interface GetTenantStatusLogsRequestParams {
    tenantId?: string;
    userId?: string;
    from?: string;
    to?: string;
    pageSize?: number;
    pageNumber?: number;
    sort?: string;
}

export class ClsGetTenantStatusLogsRequestParams {
    tenantId?: string = undefined;
    userId?: string = undefined;
    from?: string = undefined;
    to?: string = undefined;
    pageSize?: number = undefined;
    pageNumber?: number = undefined;
    sort?: string = undefined;
}

export interface GetVirtualTssStatusLogByIdRequestParams {
    tssId: string;
}

export class ClsGetVirtualTssStatusLogByIdRequestParams {
    tssId: string = undefined;
}

export interface GetVirtualTssStatusLogsRequestParams {
    tssId?: string;
    tenantId?: string;
    userId?: string;
    from?: string;
    to?: string;
    pageSize?: number;
    pageNumber?: number;
    sort?: string;
}

export class ClsGetVirtualTssStatusLogsRequestParams {
    tssId?: string = undefined;
    tenantId?: string = undefined;
    userId?: string = undefined;
    from?: string = undefined;
    to?: string = undefined;
    pageSize?: number = undefined;
    pageNumber?: number = undefined;
    sort?: string = undefined;
}


export interface AdminStatusLogApiClientInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Retrieve an information about BusinessPremises entity and tracked status changes
     * 
* @param requestParameters
     */
    getBusinessPremisesStatusLogById(requestParameters: GetBusinessPremisesStatusLogByIdRequestParams, extraHttpRequestParams?: any): Observable<BusinessPremisesWithStatusLogDTO>;

    /**
     * Retrieve an information about BusinessPremises entity and tracked status changes
     * 
* @param requestParameters
     */
    getBusinessPremisesStatusLogs(requestParameters: GetBusinessPremisesStatusLogsRequestParams, extraHttpRequestParams?: any): Observable<BusinessPremisesWithStatusLogResultResponseDTO>;

    /**
     * Retrieve an information about ERS entity and tracked status changes
     * 
* @param requestParameters
     */
    getErsStatusLogById(requestParameters: GetErsStatusLogByIdRequestParams, extraHttpRequestParams?: any): Observable<ErsWithStatusLogDTO>;

    /**
     * Retrieve an information about ERS entity and tracked status changes
     * 
* @param requestParameters
     */
    getErsStatusLogs(requestParameters: GetErsStatusLogsRequestParams, extraHttpRequestParams?: any): Observable<ErsWithStatusLogResultResponseDTO>;

    /**
     * Retrieve an information about Organization entity and tracked status changes
     * 
* @param requestParameters
     */
    getOrganizationStatusLogById(requestParameters: GetOrganizationStatusLogByIdRequestParams, extraHttpRequestParams?: any): Observable<OrganizationWithStatusLogDTO>;

    /**
     * Retrieve an information about Organization entity and tracked status changes
     * 
* @param requestParameters
     */
    getOrganizationStatusLogs(requestParameters: GetOrganizationStatusLogsRequestParams, extraHttpRequestParams?: any): Observable<OrganizationWithStatusLogResultResponseDTO>;

    /**
     * Retrieve an information about Tenant entity and tracked status changes
     * 
* @param requestParameters
     */
    getTenantStatusLogById(requestParameters: GetTenantStatusLogByIdRequestParams, extraHttpRequestParams?: any): Observable<TenantWithStatusLogDTO>;

    /**
     * Retrieve an information about Tenant entity and tracked status changes
     * 
* @param requestParameters
     */
    getTenantStatusLogs(requestParameters: GetTenantStatusLogsRequestParams, extraHttpRequestParams?: any): Observable<TenantWithStatusLogResultResponseDTO>;

    /**
     * Retrieve an information about VirtualTss entity and tracked status changes
     * 
* @param requestParameters
     */
    getVirtualTssStatusLogById(requestParameters: GetVirtualTssStatusLogByIdRequestParams, extraHttpRequestParams?: any): Observable<VirtualTssWithStatusLogDTO>;

    /**
     * Retrieve an information about VirtualTss entity and tracked status changes
     * 
* @param requestParameters
     */
    getVirtualTssStatusLogs(requestParameters: GetVirtualTssStatusLogsRequestParams, extraHttpRequestParams?: any): Observable<VirtualTssWithStatusLogResultResponseDTO>;

}
